// The message the server wrote for the person using the page, or null. Only a 400 carries one
// (UserMessageException); a 500's message is ErrorHandlerMiddleware's literal "Server error".
export function userMessageOf(error) {
  return (error?.response?.status === 400 && error.response.data?.message) || null;
}
